module.exports = __webpack_public_path__ + "img/bb.888fcff7.jpg";